import { Tune, VisibilityOutlined } from "@mui/icons-material";
import { Button, Stack } from "@mui/material";
import { SurveySettingsDrawerContent } from ".";
import { useDrawer } from "../../../../components";
import { Links } from "../../../../constants";
import { useSurveyPageLayoutContext } from "../SurveyPageLayout";

const SurveyActions = () => {
  const { survey, isLoadingSurvey } = useSurveyPageLayoutContext();
  const { showDrawer } = useDrawer();

  return (
    <>
      <Stack spacing={1} direction="row" justifyContent="space-between" alignItems="center">
        <Stack spacing={0.5} direction="row" justifyContent="space-between" alignItems="center">
          <Button
            onClick={() =>
              showDrawer({
                content: <SurveySettingsDrawerContent survey={survey!} />,
              })
            }
            disabled={isLoadingSurvey || !survey}
            variant="outlined"
            startIcon={<Tune sx={{ transform: "rotate(90deg)" }} />}
          >
            Settings
          </Button>
          <Button
            variant="outlined"
            href={survey ? Links.SurveyResponse(survey.guid) : ""}
            target="_blank"
            disabled={isLoadingSurvey || !survey}
            startIcon={<VisibilityOutlined />}
          >
            Preview
          </Button>
        </Stack>
      </Stack>
    </>
  );
};

export { SurveyActions };
